// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__4dahh","link":"styles_link__eM54E"};